/**
 * Performs a simple HTTP get and returns an object of `T` type
 * @param url url to the web service without trailing slash and id
 * @param id id of the object, if not specified, the id is not appended to url
 * @returns
 */
export class HttpError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly statusText: string,
    public readonly url: string,
  ) {
    super(message);
  }
}

export async function httpGet<T>(url: string, id?: number): Promise<T> {
  const effectiveUrl = id !== undefined ? `${url}/${id}` : url;
  const response = await fetch(effectiveUrl);

  if (!response.ok) {
    throw new HttpError(
      "Response error.",
      response.status,
      response.statusText,
      effectiveUrl,
    );
  }

  return (await response.json()) as T;
}

export default httpGet;
